import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'

import Icon from '@/atoms/Icon'
import ICONS from '@/atoms/Icon/data/icons'
import Button from '@/atoms/TempButton'

function AddToCartButton(props: AddToCartButtonProps) {
  const { className, onClick, text, icon = 'shopping_cart' } = props
  const { t } = useTranslation('products')

  return (
    <div>
      <Button
        onClick={onClick}
        type={onClick ? 'button' : 'submit'}
        className={clsx(
          'flex flex-col items-center justify-center w-full p-4 space-y-2 text-sm font-medium sm:text-base 3xs:space-y-0 3xs:flex-row 3xs:space-x-4',
          className
        )}
        variant="rounded_solid"
      >
        <Icon className="flex-shrink-0 w-4 sm:w-5" name={icon} />
        <span>{text ?? t('add_to_cart')}</span>
      </Button>
    </div>
  )
}

interface AddToCartButtonProps {
  className?: string
  icon?: keyof typeof ICONS
  onClick?(): void
  text?: string
}

export default AddToCartButton
